<template>
  <div class="legal-page">
    <header class="legal-header">
      <div class="header-container">
        <router-link to="/" class="logo-link">
          <img src="/landing/logo-white.svg" alt="Макетта" class="logo" />
        </router-link>
        <router-link to="/" class="back-link">← На главную</router-link>
      </div>
    </header>

    <main class="legal-content">
      <h1>Публичная оферта</h1>
      <p class="legal-date">Дата публикации: 14 января 2025 г.</p>

      <section class="legal-section">
        <h2>1. Общие положения</h2>
        <p>1.1. Настоящий документ является официальным предложением (публичной офертой) ИП Немыкиной Екатерины Сергеевны (далее — «Исполнитель») и содержит все существенные условия предоставления доступа к онлайн-сервису Макетта (далее — «Сервис»).</p>
        <p>1.2. В соответствии со статьёй 437 Гражданского кодекса Российской Федерации данный документ является публичной офертой.</p>
        <p>1.3. Акцептом настоящей оферты является оплата услуг Исполнителя. Моментом акцепта считается момент поступления денежных средств на расчётный счёт Исполнителя.</p>
        <p>1.4. Осуществляя акцепт оферты, Пользователь подтверждает, что ознакомлен с условиями настоящей оферты, понимает и принимает их в полном объёме.</p>
      </section>

      <section class="legal-section">
        <h2>2. Предмет оферты</h2>
        <p>2.1. Исполнитель предоставляет Пользователю возможность использования онлайн-сервиса Макетта — конструктора проектов для декораторов и ивент-специалистов.</p>
        <p>2.2. Сервис предоставляет следующие возможности:</p>
        <ul>
          <li>Создание и редактирование проектов оформления мероприятий</li>
          <li>Доступ к библиотеке элементов декора (фоны, арки, шары, цветы, текстовые элементы и др.)</li>
          <li>Автоматический расчёт сметы проекта</li>
          <li>Экспорт проектов в PDF и Excel форматы</li>
          <li>AI-обработка изображений для создания фотореалистичных визуализаций</li>
          <li>Хранение проектов в личном кабинете</li>
        </ul>
        <p>2.3. Доступ к функционалу Сервиса предоставляется на условиях подписки согласно выбранному тарифному плану.</p>
      </section>

      <section class="legal-section">
        <h2>3. Тарифные планы и стоимость услуг</h2>
        <p>3.1. Сервис предоставляет следующие тарифные планы:</p>
        
        <div class="pricing-table">
          <div class="pricing-item">
            <h3>Бесплатный тариф</h3>
            <p class="price">0 ₽ / месяц</p>
            <ul>
              <li>Ограниченный доступ к элементам декора</li>
              <li>До 3 проектов</li>
              <li>Базовые функции редактирования</li>
              <li>Экспорт в PNG</li>
            </ul>
          </div>
          
          <div class="pricing-item">
            <h3>Базовый тариф</h3>
            <p class="price">{{ formatPrice('base') }} ₽ / месяц</p>
            <ul>
              <li>Полный доступ ко всем элементам декора</li>
              <li>Неограниченное количество проектов</li>
              <li>Расширенные функции редактирования</li>
              <li>Экспорт в PDF и Excel</li>
              <li>{{ getPlanCredits('base') }} AI-обработки в месяц</li>
            </ul>
          </div>
          
          <div class="pricing-item">
            <h3>Премиум тариф</h3>
            <p class="price">{{ formatPrice('premium') }} ₽ / месяц</p>
            <ul>
              <li>Всё из базового тарифа</li>
              <li>{{ getPlanCredits('premium') }} AI-обработок в месяц</li>
              <li>Приоритетная поддержка</li>
              <li>Ранний доступ к новым функциям</li>
              <li>Персональные элементы декора</li>
            </ul>
          </div>
        </div>
        
        <p>3.2. Актуальные цены указаны на странице тарифов в личном кабинете пользователя.</p>
        <p>3.3. Исполнитель вправе изменять стоимость услуг, уведомив об этом Пользователей путём публикации новых цен на сайте.</p>
      </section>

      <section class="legal-section">
        <h2>4. Порядок предоставления услуг</h2>
        <p>4.1. Для получения доступа к Сервису Пользователь должен пройти регистрацию на сайте maketta.pro.</p>
        <p>4.2. После оплаты подписки доступ к функционалу выбранного тарифа предоставляется автоматически в течение нескольких минут.</p>
        <p>4.3. Подписка активируется с момента оплаты и действует в течение оплаченного периода (месяц).</p>
        <p>4.4. По истечении оплаченного периода подписка автоматически не продлевается. Для продолжения использования платного функционала необходимо произвести повторную оплату.</p>
      </section>

      <section class="legal-section">
        <h2>5. Права и обязанности сторон</h2>
        <p>5.1. Исполнитель обязуется:</p>
        <ul>
          <li>Обеспечить доступ к Сервису 24/7, за исключением времени проведения технических работ</li>
          <li>Сохранять конфиденциальность персональных данных Пользователя</li>
          <li>Своевременно информировать Пользователей о существенных изменениях в работе Сервиса</li>
        </ul>
        <p>5.2. Пользователь обязуется:</p>
        <ul>
          <li>Предоставлять достоверную информацию при регистрации</li>
          <li>Не передавать данные своей учётной записи третьим лицам</li>
          <li>Не использовать Сервис для незаконных целей</li>
          <li>Соблюдать авторские права на элементы, предоставленные Сервисом</li>
        </ul>
      </section>

      <section class="legal-section">
        <h2>6. Ограничение ответственности</h2>
        <p>6.1. Сервис предоставляется «как есть». Исполнитель не гарантирует, что Сервис будет соответствовать всем требованиям Пользователя.</p>
        <p>6.2. Исполнитель не несёт ответственности за временную недоступность Сервиса, вызванную техническими неполадками или проведением плановых работ.</p>
        <p>6.3. Максимальная ответственность Исполнителя ограничивается суммой, уплаченной Пользователем за текущий период подписки.</p>
      </section>

      <section class="legal-section">
        <h2>7. Возврат денежных средств</h2>
        <p>7.1. Возврат денежных средств за оплаченную подписку не производится.</p>
        <p>7.2. Пользователь может в любой момент отказаться от использования Сервиса, при этом оплаченный период подписки остаётся активным до его окончания.</p>
        <p>7.3. Подробные условия возврата описаны в <router-link to="/refund-policy">Политике возврата</router-link>.</p>
      </section>

      <section class="legal-section">
        <h2>8. Заключительные положения</h2>
        <p>8.1. Настоящая оферта вступает в силу с момента её публикации на сайте и действует бессрочно.</p>
        <p>8.2. Исполнитель оставляет за собой право вносить изменения в условия оферты без предварительного уведомления Пользователей.</p>
        <p>8.3. Все споры разрешаются путём переговоров, а при недостижении согласия — в суде по месту нахождения Исполнителя.</p>
        <p>8.4. По всем вопросам, не урегулированным настоящей офертой, стороны руководствуются законодательством Российской Федерации.</p>
      </section>

      <section class="legal-section">
        <h2>9. Реквизиты Исполнителя</h2>
        <div class="requisites">
          <p><strong>ИП Немыкина Екатерина Сергеевна</strong></p>
          <p>ОГРНИП: 325547600094265</p>
          <p>ИНН: 421717178949</p>
          <p>Email: maketta.pro@mail.ru</p>
        </div>
      </section>
    </main>

    <footer class="legal-footer">
      <p>© 2025 — {{ currentYear }} Макетта. Все права защищены.</p>
    </footer>
  </div>
</template>

<script>
import { getSubscriptionPlans } from '@/api/subscription';

export default {
  name: 'TermsOfService',
  data() {
    return {
      currentYear: new Date().getFullYear(),
      subscriptionPlans: []
    }
  },
  async mounted() {
    try {
      this.subscriptionPlans = await getSubscriptionPlans();
    } catch (e) {
      console.error('Failed to load subscription plans:', e);
    }
  },
  methods: {
    formatPrice(plan) {
      const planData = this.subscriptionPlans.find(p => p.id === plan);
      if (!planData?.price) return '...';
       return this.$formatNumber(planData.price);
    },
    getPlanCredits(plan) {
      const planData = this.subscriptionPlans.find(p => p.id === plan);
      return planData?.aiCredits ?? '...';
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  background: #f8f9fa;
}

.legal-header {
  background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
  padding: 20px 0;
  box-shadow: 0 2px 8px rgba(0,0,0,0.15);
}

.header-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.logo {
  height: 36px;
  width: 99px;
  object-fit: contain;
}

.back-link {
  color: #fff;
  text-decoration: none;
  font-weight: 500;
  opacity: 0.9;
  transition: opacity 0.2s;
}

.back-link:hover {
  opacity: 1;
}

.legal-content {
  max-width: 900px;
  margin: 0 auto;
  padding: 40px 20px;
  background: #fff;
  margin-top: 20px;
  margin-bottom: 20px;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.05);
}

h1 {
  font-size: 32px;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.legal-date {
  color: #666;
  margin-bottom: 40px;
}

.legal-section {
  margin-bottom: 30px;
}

.legal-section h2 {
  font-size: 20px;
  color: #1a1a2e;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
}

.legal-section p {
  color: #444;
  line-height: 1.7;
  margin-bottom: 10px;
}

.legal-section ul {
  margin: 10px 0 10px 20px;
  color: #444;
  line-height: 1.7;
}

.legal-section li {
  margin-bottom: 5px;
}

.pricing-table {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 20px 0;
}

.pricing-item {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 12px;
  border: 1px solid #e0e0e0;
}

.pricing-item h3 {
  font-size: 18px;
  color: #1a1a2e;
  margin-bottom: 10px;
}

.pricing-item .price {
  font-size: 24px;
  font-weight: 700;
  color: #6366f1;
  margin-bottom: 15px;
}

.pricing-item ul {
  margin: 0;
  padding-left: 20px;
}

.pricing-item li {
  font-size: 14px;
  color: #555;
}

.requisites {
  background: #f8f9fa;
  padding: 20px;
  border-radius: 8px;
}

.requisites p {
  margin-bottom: 5px;
}

.legal-footer {
  text-align: center;
  padding: 30px;
  color: #666;
}

@media (max-width: 768px) {
  h1 {
    font-size: 24px;
  }
  
  .legal-content {
    padding: 20px 15px;
  }
  
  .pricing-table {
    grid-template-columns: 1fr;
  }
}
</style>
